import React, { memo } from 'react'
import { useCalculateButtonStyles } from 'src/editor/shared/hooks/use-calculate-button-styles'
import { Button as CommonButton } from 'src/shared/components/button/button'
import { CommonButtonEntityInterface } from 'src/shared/schemas/buttons/common-button-entity.schema'
import { CommonButtonSubEntityInterface } from 'src/shared/schemas/buttons/common-button-sub-entity.schema'

interface CommonEditorButtonEntityOrSubEntityProps {
  entityOrSubEntity:
    | CommonButtonEntityInterface
    | CommonButtonSubEntityInterface
}

// TODO: reuse it in other button components
export const CommonEditorButtonEntityOrSubEntity = memo(
  ({ entityOrSubEntity }: CommonEditorButtonEntityOrSubEntityProps) => {
    const {
      calculatedBorder,
      calculatedPadding,
      calculatedFontSize,
      calculatedLineHeight,
      calculatedFontFamily,
      calculatedFontWeight,
      calculatedFontStyle,
      calculatedTextColor,
      calculatedBackground,
      calculatedHover,
    } = useCalculateButtonStyles({
      border: entityOrSubEntity.border,
      mobileBorder: entityOrSubEntity.mobileBorder,
      padding: entityOrSubEntity.padding,
      mobilePadding: entityOrSubEntity.mobilePadding,
      buttonType: entityOrSubEntity.buttonType,
      fontSize: entityOrSubEntity.textFontSize,
      mobileFontSize: entityOrSubEntity.mobileTextFontSize,
      lineHeight: entityOrSubEntity.lineHeight,
      mobileLineHeight: entityOrSubEntity.mobileLineHeight,
      fontFamily: entityOrSubEntity.textFontFamily,
      mobileFontFamily: entityOrSubEntity.mobileTextFontFamily,
      fontWeight: entityOrSubEntity.textFontWeight,
      mobileFontWeight: entityOrSubEntity.mobileTextFontWeight,
      fontStyle: entityOrSubEntity.textFontStyle,
      mobileFontStyle: entityOrSubEntity.mobileTextFontStyle,
      textColor: entityOrSubEntity.textColor,
      mobileTextColor: entityOrSubEntity.mobileTextColor,
      background: entityOrSubEntity.background,
      mobileBackground: entityOrSubEntity.mobileBackground,
      backgroundColor: entityOrSubEntity.backgroundColor,
      mobileBackgroundColor: entityOrSubEntity.mobileBackgroundColor,
      hover: entityOrSubEntity.hover,
      mobileHover: entityOrSubEntity.mobileHover,
    })

    return (
      <CommonButton
        iconClassNameBefore={entityOrSubEntity.iconClassNameBefore}
        iconClassNameAfter={entityOrSubEntity.iconClassNameAfter}
        text={entityOrSubEntity.text}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        subText={entityOrSubEntity.subText}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        alignSelf={entityOrSubEntity.alignSelf}
        mobileAlignSelf={entityOrSubEntity.mobileAlignSelf}
        background={calculatedBackground.desktop}
        mobileBackground={calculatedBackground.mobile}
        attrId={entityOrSubEntity.htmlAttrId}
        width={entityOrSubEntity.width}
        mobileWidth={entityOrSubEntity.mobileWidth}
        textColor={calculatedTextColor.desktop}
        mobileTextColor={calculatedTextColor.mobile}
        mobileSubTextColor={entityOrSubEntity.mobileSubTextColor}
        subTextColor={entityOrSubEntity.subTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        subTextFontSize={entityOrSubEntity.subTextFontSize}
        mobileSubTextFontSize={entityOrSubEntity.mobileSubTextFontSize}
        textFontFamily={calculatedFontFamily.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        lineHeight={calculatedLineHeight.desktop}
        subTextFontFamily={entityOrSubEntity.subTextFontFamily}
        subTextFontWeight={entityOrSubEntity.subTextFontWeight}
        subTextFontStyle={entityOrSubEntity.subTextFontStyle}
        mobileTextFontFamily={calculatedFontFamily.mobile}
        mobileTextFontWeight={calculatedFontWeight.mobile}
        mobileTextFontStyle={calculatedFontStyle.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileSubTextFontFamily={entityOrSubEntity.mobileSubTextFontFamily}
        mobileSubTextFontWeight={entityOrSubEntity.mobileSubTextFontWeight}
        mobileSubTextFontStyle={entityOrSubEntity.mobileSubTextFontStyle}
        boxShadow={entityOrSubEntity.boxShadow}
        mobileBoxShadow={entityOrSubEntity.mobileBoxShadow}
        hover={calculatedHover.desktop}
        mobileHover={calculatedHover.mobile}
      />
    )
  },
)
